/**
 * Actions Types
 */
export const NOTIFICATIONS_CHECK = 'notification/NOTIFICATIONS_CHECK';

export const REQUEST_NOTIFICATIONS_PERMISSION = 'notification/REQUEST_NOTIFICATIONS_PERMISSION';

export const ADD_NOTIFICATION = 'notification/ADD_NOTIFICATION';
export const SHOW_NOTIFICATION = 'notification/SHOW_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'notification/REMOVE_NOTIFICATION';
export const REPLY_REMINDER_SHOWN = 'notification/REPLY_REMINDER_SHOWN';
export const UPDATE_NOTIFICATIONS_TYPE = 'notification/UPDATE_NOTIFICATIONS_TYPE';

export const NOTIFICATIONS_SUBSCRIBE = 'notification/NOTIFICATIONS_SUBSCRIBE';
export const NOTIFICATIONS_UNSUBSCRIBE = 'notification/NOTIFICATIONS_UNSUBSCRIBE';

export const NOTIFICATIONS_SUBSCRIBE_SUCCESS = 'notification/NOTIFICATIONS_SUBSCRIBE_SUCCESS';
export const NOTIFICATIONS_UNSUBSCRIBE_SUCCESS = 'notification/NOTIFICATIONS_UNSUBSCRIBE_SUCCESS';

export const TINDER_SUBSCRIBE_SUCCESS = 'notification/TINDER_SUBSCRIBE_SUCCESS';
export const TINDER_UNSUBSCRIBE_SUCCESS = 'notification/TINDER_UNSUBSCRIBE_SUCCESS';

export const SHOW_HOMESCREEN_PROMPT = 'notification/SHOW_HOMESCREEN_PROMPT';
export const SHOW_ADD_TO_HOMESCREEN_IOS_TOOLTIP = 'notification/SHOW_ADD_TO_HOMESCREEN_IOS_TOOLTIP';
export const HIDE_ADD_TO_HOMESCREEN_IOS_TOOLTIP = 'notification/HIDE_ADD_TO_HOMESCREEN_IOS_TOOLTIP';

export const RESET_NOTIFICATIONS = 'notification/RESET_NOTIFICATIONS';

// Categories (user preferences)
export const NOTIFICATION_CATEGORY_MESSAGE = 'message';
export const NOTIFICATION_CATEGORY_MATCH = 'match';
export const NOTIFICATION_CATEGORY_LIKED_MESSAGE = 'messageLike';
export const NOTIFICATION_CATEGORY_SUPER_LIKED = 'superLike';
